import { render, staticRenderFns } from "./WorkspacesComp.vue?vue&type=template&id=0df0ebca&scoped=true&"
import script from "./WorkspacesComp.vue?vue&type=script&lang=js&"
export * from "./WorkspacesComp.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacesComp.vue?vue&type=style&index=0&id=0df0ebca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0ebca",
  null
  
)

export default component.exports